/* ============
 * Getters for the organization conf module
 * ============
 *
 * The getters that are available on the
 * organization conf module.
 */

export default {
  docTypes: state => state.docTypes.sort((a, b) => a.description.localeCompare(b.description)),
};



// WEBPACK FOOTER //
// ./src/store/modules/organization-conf/getters.js